import apiClient from '../client'
import type { ExportColumnSetting, ExportColumnSettingUpsert } from './types'

const mgmtBase = (municipalityId: number) =>
  `/api/municipalities/${municipalityId}/export-column-settings/recipients-csv`

export const exportColumnSettingsApi = {
  // ── ログインユーザー自治体スコープ版（独立管理画面 /admin/recipient-csv-columns 用。ADMIN）──
  /** 自分の自治体の受給者一覧CSV出力項目を取得する。 */
  getForMyMunicipality() {
    return apiClient.get<ExportColumnSetting>('/api/admin/export-column-settings/recipients-csv')
  },
  /** 自分の自治体の受給者一覧CSV出力項目を保存する。 */
  saveForMyMunicipality(body: ExportColumnSettingUpsert) {
    return apiClient.put<ExportColumnSetting>('/api/admin/export-column-settings/recipients-csv', body, {
      _silent: true,
    })
  },

  // ── パス固定版（SYSTEM_ADMIN が自治体を選んで維護。MUNICIPALITY_MGMT）──
  /** 指定自治体の受給者一覧CSV出力項目を取得する。 */
  getForManagement(municipalityId: number) {
    return apiClient.get<ExportColumnSetting>(mgmtBase(municipalityId))
  },
  /** 指定自治体の受給者一覧CSV出力項目を保存する。 */
  saveForManagement(municipalityId: number, body: ExportColumnSettingUpsert) {
    return apiClient.put<ExportColumnSetting>(mgmtBase(municipalityId), body, { _silent: true })
  },
}
